import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { CuraleafFonts, JarsFonts } from 'shared/utils/customize';

type FontLoaderProps = {
  encodedFonts?: string;
};

/** Loads configured Google fonts and entitlement-gated chain fonts. */
export function FontLoader({ encodedFonts }: FontLoaderProps): JSX.Element {
  const flags = useFlags();
  const isCuraleafFontsEnabled = flags['growth.ecomm.curaleaf-fonts.entitlement'] ?? false;
  const isJarsFontsEnabled = flags['growth.ecomm.jars-fonts.entitlement'] ?? false;

  return (
    <>
      {isCuraleafFontsEnabled && <CuraleafFonts />}
      {isJarsFontsEnabled && <JarsFonts />}
      {encodedFonts && (
        <link href={`https://fonts.googleapis.com/css2?${encodedFonts}&display=swap`} rel='stylesheet' />
      )}
    </>
  );
}
